import React from 'react';
import classnames from 'classnames';
import Markdown from 'markdown-to-jsx';
import deepMerge from 'deepmerge';
import { Heading, Text, TextLink } from '../index';
import styles from "./richtext.module.css";
const baseClass = 'richtext';
const RichtextTextLink = ({ children, ...props }) => (React.createElement(TextLink, { ...props, linkText: children }));
export const defaultOverrides = {
    h1: {
        component: Heading,
        props: {
            tag: 'h1',
            variant: 'display-functional-200',
            className: styles.h1
        }
    },
    h2: {
        component: Heading,
        props: {
            tag: 'h2',
            variant: 'headline-functional-100',
            className: styles.h2
        }
    },
    h3: {
        component: Heading,
        props: {
            tag: 'h3',
            variant: 'headline-functional-200',
            className: styles.h3
        }
    },
    h4: {
        component: Heading,
        props: {
            tag: 'h4',
            variant: 'headline-functional-300',
            className: styles.h4
        }
    },
    h5: {
        component: Heading,
        props: {
            tag: 'h5',
            variant: 'headline-functional-400',
            className: styles.h5
        }
    },
    h6: {
        component: Heading,
        props: {
            tag: 'h6',
            variant: 'headline-functional-400',
            className: styles.h6
        }
    },
    table: {
        props: {
            className: styles.table
        }
    },
    blockquote: {
        props: {
            className: styles.defaultText
        }
    },
    code: {
        props: {
            className: styles.defaultText
        }
    },
    pre: {
        props: {
            className: styles.defaultText
        }
    },
    p: {
        props: {
            tag: 'p',
            variant: 'paragraph-100',
            className: styles.p
        },
        component: Text
    },
    a: {
        component: RichtextTextLink,
        props: {
            variant: 'hyperlink-100',
            className: styles.a
        }
    },
    ul: {
        props: {
            className: styles.ul
        }
    },
    ol: {
        props: {
            className: styles.ol
        }
    },
    li: {
        props: {
            className: styles.li
        }
    },
    frame: {
        props: {
            tag: 'div',
            className: styles.frame
        }
    }
};
const legalOverrides = {
    p: {
        props: {
            tag: 'p',
            variant: 'legal-100',
            className: styles.p
        },
        component: Text
    },
    a: {
        component: RichtextTextLink,
        props: {
            variant: 'hyperlink-legal',
            className: styles.a
        }
    }
};
export const RichText = ({ className, mdString, isLegal, wrapperElement, customOverrides = {}, enableParsingRawHtml }) => {
    const classes = classnames(styles[baseClass], className, {
        [styles[`${baseClass}--legal`]]: isLegal
    });
    const children = (mdString ?? '')
        .replace(/\\(?=[.?*+[\]{}()^$|\\])/gi, '')
        .replace(/\\n/gi, '\n')
        .replace(/\\&nbsp;/gi, `\
      `);
    const overrides = React.useMemo(() => deepMerge({ ...defaultOverrides, ...(isLegal ? legalOverrides : {}) }, customOverrides), [isLegal, customOverrides]);
    return (React.createElement(Markdown, { options: {
            overrides,
            forceBlock: true,
            disableParsingRawHTML: !enableParsingRawHtml,
            wrapper: wrapperElement,
            forceWrapper: true
        }, className: classes, "data-testid": "richtext-component" }, children));
};
//# sourceMappingURL=index.js.map